<template>
  <AuModal
    :model-value="modelValue"
    width="350px"
    @update:modelValue="value => $emit('update:modelValue', value)"
  >
    <template #header>
      <span class="modal_head_text">
        {{ localizedHeaderText }}
      </span>
    </template>
    <template #body>
      <span>
        {{ bodyText }}
      </span>
    </template>
    <template #footer>
      <div class="modal_buttons">
        <AuButton
          bordered
          center
          width="100%"
          @click="confirm"
        >
          {{ localizedConfirm }}
        </AuButton>
        <AuButton
          bordered
          center
          width="100%"
          @click="decline"
        >
          {{ localizedDecline }}
        </AuButton>
      </div>
    </template>
  </AuModal>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    headerText: {
      type: String,
      default: ""
    },
    bodyText: {
      type: String,
      default: ""
    },
    confirmButtonText: {
      type: String,
      default: ""
    },
    declineButtonText: {
      type: String,
      default: ""
    }
  },

  emits: ["update:modelValue"],

  computed: {
    localizedHeaderText() {
      return this.headerText || this.$t("modalDialog.headerText");
    },
    localizedConfirm() {
      return this.confirmButtonText || this.$t("modalDialog.confirmButtonText");
    },
    localizedDecline() {
      return this.headerText || this.$t("modalDialog.declineButtonText");
    }
  },

  methods: {
    decline() {
      this.$emit("update:modelValue", false);
      this.$emit("decline");
    },

    confirm() {
      this.$emit("update:modelValue", false);
      this.$emit("confirm");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {

  &_head_text {
    font-weight: 450;
    font-size: 20px;
    margin-bottom: 20px;
  }

  &_buttons {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    margin-top: 20px
  }
}
</style>